/**
 * Takes in a valid query string and generates an object
 * @param {*} str querystring from url
 */
export function fromQueryString(str) {
  return Object.fromEntries(new URLSearchParams(str).entries());
}
